import React, { useState } from 'react';
import { X, Zap } from 'lucide-react';

const UrgencyBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Vi a promoção e gostaria de solicitar um orçamento.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-[#f97316] to-[#fb923c] text-white py-2 px-4 relative">
      <div className="container mx-auto flex items-center justify-center gap-3 text-center">
        <Zap className="w-5 h-5 animate-pulse flex-shrink-0" />
        <p className="text-sm md:text-base font-semibold">
          <span className="hidden md:inline">🔥 ATENDIMENTO EXPRESSO: </span>
          Chame agora e ganhe <span className="underline">10% de desconto</span> no seu primeiro serviço!
          <button
            onClick={() => window.open(whatsappLink, '_blank')}
            className="ml-3 bg-white text-[#f97316] px-4 py-1 rounded-full font-bold hover:bg-gray-100 transition-colors inline-block"
          >
            Pedir Agora
          </button>
        </p>
        <button
          onClick={() => setIsVisible(false)}
          className="ml-auto text-white hover:text-gray-200 transition-colors flex-shrink-0"
          aria-label="Fechar banner"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default UrgencyBanner;
